import { useCallback, useState } from 'react';
import DateFormat from 'src/components/DateFormat';
import Loader from 'src/components/loader';
import ScrollTable from 'src/components/table/infiniteScroll';
import Service from 'src/setup/network';
import DateRangePickerWithTime from './datePicker';
import { CurrencyAmount } from 'src/containers/currency';

const initTableColumn = [
  {
    Header: 'Date',
    accessor: 'a',
    Cell: (row: any) => (
      <div className="w-auto">
        {<DateFormat text={row?.cell?.row?.original?.createdAt} />}
      </div>
    ),
  },
  {
    Header: 'Order ID',
    accessor: 'referenceNumber',
    Cell: (row: any) => (
      <p>{`#${row?.cell?.row?.original?.referenceNumber}`}</p>
    ),
  },
];

const SalesSummary = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [orderData, setOrderData] = useState<any[]>([]);
  const [tableColumn, setTableColumn] = useState(initTableColumn);
  const [summaryData, setSummaryData] = useState([]);
  const [totalSummary, setTotalSummary] = useState(null);

  const fetchOrderData = useCallback(async (querySend: string) => {
    setIsLoading(true);
    try {
      const res = await Service.get(`/payments/receipt/summary${querySend}`);
      const data = await res?.data;
      const methods = data?.paymentMethodSummaries;
      setOrderData(data?.receipts);
      setSummaryData(methods.filter((item: any) => item.id !== 'NA'));
      setTotalSummary(data?.receiptsTotal);
      setIsLoading(false);
      const cols: any = [...tableColumn];
      methods.forEach((element: any) => {
        if (element.paymentMethodId === 'NA') return;
        const paymentMethodId =
          element.paymentMethodId === 'NA' ? null : element.paymentMethodId;
        cols.push({
          Header: element.paymentMethod ?? 'N/A',
          accessor: element.name,
          Cell: (row: any) => {
            const transcInfo = row?.cell?.row?.original?.transactions?.find(
              (x: any) => x.paymentMethodId === paymentMethodId
            );
            return (
              <p>{`${
                transcInfo?.amount ? <CurrencyAmount amount={transcInfo?.amount}/> : ''
              }`}</p>
            );
          },
        });
      });
      cols.push({
        Header: 'Total',
        accessor: 'aa',
        Cell: (row: any) => {
          return (
            <p>{`${
              row?.cell?.row?.original?.total
                ? <CurrencyAmount amount={row?.cell?.row?.original?.total}/>
                : ''
            }`}</p>
          );
        },
      });
      setTableColumn(cols);
    } catch (err) {}
  }, []);

  const getSummaryValuesData = [
    { total: 'Total' },
    null,
    ...summaryData,
    { total: totalSummary },
  ];

  return (
    <>
      <div className="pb-10 flex flex-col">
        <div className="flex gap-2 items-center ml-auto">
          {DateRangePickerWithTime(fetchOrderData)}
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <ScrollTable
            tableColumn={tableColumn}
            tableData={orderData}
            getSummaryValuesData={getSummaryValuesData}
          />
        )}
      </div>
    </>
  );
};

export default SalesSummary;
